import getReportsStore from ".";
import { apiCallResolveReport } from "../../api/report-api/api-call-handle-report";
import getCleanPoolStore from "../core/core-clean-pool";
import getCorePopUpStore from "../core/core-popup-store";
import getCoreUIStore from "../core/core-ui-store";

const resolveReportOnDatabase = async ({
  reportId,
  reportedId,
  type
}: {
  reportId: number;
  reportedId: number;
  type: "resolve" | "email";
}) => {
  getCoreUIStore().setIsLoading("REPORTS", true);
  const { status, data, code } = await apiCallResolveReport({
    reportId,
    reportedId,
    type
  });
  getCoreUIStore().setIsLoading("REPORTS", false);
  if (status === "OK") {
    getCorePopUpStore().showSuccessMessage(data);
    getReportsStore().removePendingReport({ reportId, reportedId });
    getReportsStore().decreaseDashboardReportsCount();
    getReportsStore().decreaseDashboardReportedCount(reportedId);
  } else {
    if (code === "NO_LONGER_ACTIVE_POOL") {
      await getCleanPoolStore().automaticCleanPool({
        type: "REPORT"
      });
    }
    getCorePopUpStore().showAlertMessage(code);
  }
};

export default resolveReportOnDatabase;
